<template>
  <section class="app-transporte">
    <v-container grid-list-xl style="max-width: 600px">
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <section class="d-flex justify-center">
            <img width="130" src="@/assets/vai-vem/vaivem-icon.svg" />
          </section>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title justify-center">VaiVem</v-card-title>
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.email"
                      placeholder="Digite seu Email"
                      label="Email *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.senha"
                      placeholder="Digite sua Senha"
                      label="Senha *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      type="password"
                    />
                  </v-col>
                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-input
                        v-model="form.recaptcha"
                        :rules="[rules.required]"
                        hide-details="auto"
                        class="recaptcha-input"
                      >
                        <template #default>
                          <div class="recaptcha-wrapper">
                            <vue-recaptcha
                              ref="recaptcha"
                              :sitekey="siteKey"
                              :loadRecaptchaScript="true"
                              @verify="verifyRecaptcha"
                              @expired="expiredRecaptcha"
                            />
                          </div>
                        </template>
                      </v-input>
                    </v-col>
                  </v-row>
                  <v-row class="justify-end mr-2 ml-2">
                    <v-col :md="3" :sm="3" :xs="12" cols="6">
                      <v-btn @click="limpar" depressed block large style="color: #1976d2; background-color: #d5e9ef"
                      >Limpar</v-btn>
                    </v-col>
                    <v-col :md="3" :sm="3" :xs="12" cols="6">
                      <v-btn depressed block large color="primary" @click="onSubmit"
                      >Continuar</v-btn>
                    </v-col>
                  </v-row>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import VaiVemAuthService from "@/services/vai-vem.auth.service";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";

dayjs.extend(customParseFormat).locale("pt-BR");

export default {
  metaInfo: {
    title: "VaiVem",
  },
  components: {
    VueRecaptcha,
  },
  directives: {
    mask,
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    form: {
      email: "",
      senha: "",
      recaptcha: null,
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
    },
    alert: false,
    msg: "",
  }),
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { email, senha } = this.form;
        VaiVemAuthService.login(email, senha).subscribe(
          (res) => {
            this.isLoading = false;
            return res;
          },
          (err) => {
            this.isLoading = false;
            this.alert = true;
            this.msg = err.msg;
          }
        );
      }
    },
    limpar() {
      this.$refs.form.reset();
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}

/* ajustes do recaptcha centralizado */
.recaptcha-input {
  display: inline-block !important;
  width: auto !important;
  max-width: 340px;
}

.recaptcha-input ::v-deep(.v-input__slot) {
  padding: 0 !important;
}

.recaptcha-input ::v-deep(.v-input__control) {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.recaptcha-wrapper {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

.recaptcha-wrapper ::v-deep(.g-recaptcha) {
  display: block !important;
  margin: 0 auto !important;
}
</style>
